import React from "react"
import { graphql } from "gatsby"

import SEO from "../components/seo"
import Layout from "../components/Layout"
import { MDXRenderer } from "gatsby-plugin-mdx"

export default function Template({ data, pageContext, location }) {
  const { mdx } = data
  const { frontmatter, body } = mdx
  console.log({ frontmatter })
  return (
    <Layout>
      <SEO title={frontmatter.title} />
      <MDXRenderer>{body}</MDXRenderer>
    </Layout>
  )
}
export const pageQuery = graphql`
  query ($path: String!) {
    mdx(frontmatter: { path: { eq: $path } }) {
      body
      frontmatter {
        path
        title
      }
    }
  }
`
